import { JSX } from "react";

import Spinner from "@/components/helpers/Spinner/Spinner.tsx";

import { cn } from "@/utils/cn.ts";

interface LoaderProps {
  spinnerClassName?: string;
  className?: string;
}

const Loader = ({ className, spinnerClassName }: LoaderProps): JSX.Element => {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <Spinner className={spinnerClassName} />
    </div>
  );
};

export default Loader;
